import { UserLevel, SubscriptionLevel } from '../lib/api';

interface UserBadgeProps {
  user_level: UserLevel;
  subscription_level?: SubscriptionLevel | null;
  size?: 'xs' | 'sm';
  className?: string;
}

export default function UserBadge({
  user_level: _user_level,
  subscription_level: _subscription_level,
  size: _size = 'xs',
  className: _className = ''
}: UserBadgeProps) {
  // TODO [VERIFIED 2025-12-07]: Re-enable when badge icons are designed
  // Component implementation exists but returns null to hide all badges
  // Blocker: Need visual design for founder, employee, VIP badges
  // Backend ready: users.user_affiliation field stores badge types
  return null;

  // Get display text and styling based on user level
  /* const getBadgeProps = () => {
    switch (user_level) {
      case 'founder':
        return {
          text: 'FOUNDER',
          className: 'bg-gradient-to-r from-yellow-400 to-orange-500 text-black font-bold'
        };
      case 'free':
      default:
        return null;
    }
  };

  const badgeProps = getBadgeProps();

  // Don't render anything if no badge props
  if (!badgeProps) return null;

  const { text, className: badgeClassName } = badgeProps;

  return (
    <span className={`
      inline-block rounded-full uppercase tracking-wide
      ${sizeClasses[size]}
      ${badgeClassName}
      ${className}
    `}>
      {text}
    </span>
  ); */
}